import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';

import find from 'lodash/find'

import * as deleteTeam from '../../../actions/teamdetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class DeleteTeam extends Component {

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        this.props.closeDialog();
        this.props.actions.deleteTeamDetails(Number(this.props.data.id));
    };

    render() {
        const { id } = this.props;
        return (
            <div>
            <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                <DialogTitle className="bg-primary">
                    <span className="text-white">Delete Team</span>
                </DialogTitle>
                <DialogContent>
                    <div className="row p-4">
                        <div className="col-md-12">
                            Do you want to delete the Team Details?
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                    <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Delete</Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(deleteTeam, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DeleteTeam);


// WEBPACK FOOTER //
// ./app/teamdetails/teamlist/deleteteam.js